import Campaign from './campaign';
import AdGroup from './adGroup';

export default { Campaign, AdGroup };
